export const dymitrLeszko = {
    'meta': {
        'title': 'Psycholog, Psychoterapeuta Dymitr Leszko • Centrum COLLIGO',
        'description': 'Jestem psychologiem, psychoterapeutą (w nurtach: pozytywnym i poznawczo-behawioralnym). Prowadzę też terapię schematu oraz terapię skoncentrowaną na emocjach.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-dymitr-leszko/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/dymitr-leszko.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, Psychoterapeuta Dymitr Leszko'
        }
    }
}